<template>
  <div class="billingHistory">
    <div class="section" v-if="!showInvoiceView">
      <!-- 搜索栏 -->
      <div class="search">
        <div class="datePreNext">
          <!-- <el-date-picker :editable='false' @change="queryData(true)" clearable v-model="datevalue"
            type="daterange" align="left" unlink-panels ref="datePickerRange"
            :range-separator="$t('report.to')"
            :default-value="new Date().setMonth(new Date().getMonth() - 1)"
            :picker-options="pickerrangeOptions" :start-placeholder="$t('report.start_date')"
            :end-placeholder="$t('report.End_date')" popper-class="select-date1">
          </el-date-picker> -->
        <span class="date-icon"></span>
        <!-- 上一天 -->
        <span class="date-btn date-pre" @click="toPreDay"></span>
          <el-date-picker v-model="datevalue" :editable="false" popper-class="select-date"
          :picker-options="pickerrangeOptions" @change="queryData(true)" :placeholder="$t('rosRecharge.pleaseSelectDate')"
          ref="datePickerRange"></el-date-picker>
        <span class="date-btn date-next" @click="toNextDay"></span>
        </div>
        <el-button class="button button-solid" @click.stop="showSearchBtn">
          <i class="el-icon-search"></i>
        </el-button>
        <div class="search-alert" v-show="showSearch">
          <div class="searchDiv">
            <el-input
              class="searchAll"
              ref="iptFocus"
              v-model.trim="searchDatalogger.orderno"
              @keyup.enter.native="queryData(true)"
              :placeholder="$t('rosRecharge.orderNo')"
              clearable
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <span class="search-device" @click="queryData(true)">{{ $t('recharge.Search') }}</span>
            <span class="search-hide" @click="closeSearch">{{ $t('datalogger.cancel') }}</span>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        height="100%"
        class="tablemain tableloding"
        border
        v-loading="elLoading"
        :data="dataloggerList"
        stripe
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        element-loading-spinner="el-icon-loading"
        :empty-text="$t('account.nodata')"
      >
        <el-table-column prop="orderNo" :label="$t('recharge.Order_Number')" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="orderName" :label="$t('rosRecharge.rechargeType')" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('recharge.Recharge_money')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>¥{{ scope.row.totalAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('rosRecharge.invoiceStatus')" min-width="105" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span
              v-if="scope.row.invoiceStatus !== undefined && invoiceStatusMap[scope.row.invoiceStatus]"
              :class="`color-${invoiceStatusMap[scope.row.invoiceStatus].class}`"
            >
              {{ invoiceStatusMap[scope.row.invoiceStatus].label }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('rosRecharge.invoiceTime')" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('recharge.Operation')" fixed="right" width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              :title="$t('rosRecharge.viewDetail')"
              @click="viewInvoiceResult(scope.row)"
            >
              <!-- <i class="ico iconfont icon-invoiceList"></i> -->
              <img src="@/assets/img/recharge/billing.png" class="ico" alt="">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="tablebottom">
        <div style="margin-left:10px;"></div>
        <el-pagination
          class="pagination"
          background
          @size-change="queryData(true)"
          @current-change="() => queryData()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <invoice-view
      v-else
      :invoiceResult="currentInvoiceResult"
      :status="currentInvoiceStatus"
      @back="handleInvoiceViewBack"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import filter from "@/assets/js/filter";
import invoiceView from "./invoiceView";

export default {
  components: { invoiceView },
  data() {
    return {
      datevalue: "",
      pickerrangeOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now() - 8.64e6
        },
      },
      searchDatalogger: {
        orderno: ""
      },
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      },
      // 发票状态映射
      invoiceStatusMap: {
        "00": { class: "pending", label: this.$t("rosRecharge.invoicing") },
        "01": { class: "normal", label: this.$t("rosRecharge.invoiceSuccess") },
        "02": { class: "fault", label: this.$t("rosRecharge.invoiceFailed") }
      },
      dataloggerList: [],
      elLoading: false,
      showSearch: false,
      // 查看开票结果
      showInvoiceView: false,
      currentInvoiceResult: null,
      currentInvoiceStatus: 'pending',
    };
  },
  mounted() {
    this.queryData();
  },
  computed: {
    ...mapState({
      role: state => {
        return {
          id: state.user.role,
          name: filter.role(state.user.role).name,
          group: filter.role(state.user.role).group
        };
      }
    })
  },
  methods: {
    // 切换上一天
    toPreDay () {
      let aimTime = this.$filter.formatDate(this.$refs.datePickerRange.value, "yyyy-MM-dd");
      let preDay = this.$tool.getYestoday(aimTime);
      // this.datevalue = preDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(preDay)) {
        const [y, m, d] = preDay.split('-');
        this.datevalue = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.datevalue = preDay;
      }
    },
    // 切换下一天
    toNextDay () {
      let dayValue= new Date(this.$refs.datePickerRange.value)
      if (dayValue>Date.now()-8.64e7) return this.$message.warning(this.$t("device.noDate"));
      let aimTime = this.$filter.formatDate(this.$refs.datePickerRange.value, "yyyy-MM-dd");
      let nextDay = this.$tool.getNextday(aimTime);
      // this.datevalue = nextDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(nextDay)) {
        const [y, m, d] = nextDay.split('-');
        this.datevalue = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.datevalue = nextDay;
      }
    },
    queryData(reset) {
      if (reset) this.pagination.currentPage = 1;
      let param = {
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
        orderno: this.searchDatalogger.orderno,
        date: this.datevalue ? this.$filter.formatDate(this.datevalue, "yyyy-MM-dd") : "",
      };
      if (this.datevalue && this.datevalue.length === 2) {
        param.startTime = this.datevalue[0];
        param.endTime = this.datevalue[1];
      }
      this.elLoading = true;
      this.$request.getDEVMicroservices("/ros/api/rechargeInvoice/listInvoiceHistory", param).then(res => {
        if (res.code == 0) {
          this.dataloggerList = res.data.invoice;
          this.pagination.total = res.data.total;
        } else {
          this.dataloggerList = [];
          this.pagination.total = 0;
        }
        this.elLoading = false;
      });
    },
    closeSearch() {
      this.showSearch = false;
      this.searchDatalogger.orderno = "";
      this.queryData(true);
    },
    showSearchBtn() {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    // 查看开票结果
    viewInvoiceResult(row) {
      const statusMap = { "00": 'pending', "01": 'success', "02": 'fail' };
      this.currentInvoiceStatus = statusMap[row.invoiceStatus] || 'pending';
      this.currentInvoiceResult = row;
      this.showInvoiceView = true;
    },
    handleInvoiceViewBack() {
      this.showInvoiceView = false;
      this.currentInvoiceResult = null;
      this.queryData(true)
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.billingHistory {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  overflow: auto;

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  /deep/.el-range__icon {
    margin-left: 25px;
  }

  /deep/.el-date-editor--daterange {
    color: #fff;
    background-color: #2b3842;
  }

  /deep/.el-range-input {
    color: #fff;
    background-color: #222d35;
    width: 160px;
  }

  /deep/.el-range-separator {
    color: #fff;
    width: 18%;
    line-height: 48px;
  }

  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 12px;
    left: 10px;
    height: 24px;
    width: 24px;
    background: url(../../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {
          /deep/.el-input__inner {
            width: 220px;
            // padding-left: 10px;
              padding: 0 20px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        // /deep/.el-input .el-input__clear {
        //   width: 48px;
        //   color: #7b8395;
        // }

        // /deep/.el-input .el-input__clear:hover {
        //   background: @primaryColorTransparency30;
        //   color: rgb(255, 255, 255, 1);
        // }

        // /deep/.el-input .el-input__inner,
        // /deep/.el-input .el-input__inner:hover {
        //   height: 48px;
        //   border-radius: 0px;
        //   border: none;
        //   background: #202d35;
        //   color: #ffffff;
        //   padding-left: 40px;
        // }

        // /deep/.el-input__prefix {
        //   left: 0px;
        // }

        // /deep/.el-input__icon {
        //   width: 40px;
        // }

        // /deep/.el-input__suffix {
        //   right: 0px;
        // }

        // /deep/.el-input__suffix:hover {
        //   background: @primaryColorTransparency30;
        //   color: rgb(255, 255, 255, 1);
        // }

        // /deep/.el-icon-circle-close:before {
        //   content: "X";
        // }

        // /deep/.el-input:not(:last-child) {
        //   margin-right: 0px;
        // }
      }
     // 日期盒子
    .datePreNext {
      padding: 0px 16px;
      // border-left: 1px solid #7B8395;
      border-right: 1px solid #7B8395;

      /deep/.datepicker {
        margin: 0px;
        // margin-right: 16px;
      }

      /deep/.el-date-editor {
        margin-right: 16px;
      }

      /deep/.el-date-editor.el-input {
        width: 150px;
      }

      /deep/.el-date-editor.el-input .el-input__inner {
        padding: 0px;
        text-align: center;
      }

      //.el-input__prefix,
      //.el-input__suffix
      /deep/.el-input__prefix {
        display: none;
      }

      /deep/.el-input__suffix {
        top: 2px;
        right: 0px;
      }

      .date-icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url(../../../assets/img/general/Icon_Calendar.png);
        background-size: 100%;
        background-position: center;
        background-repeat: no-repeat;
        vertical-align: middle;
        margin-right: 16px;
      }

      .date-pre {
        background: url(../../../assets/img/general/Chart_Date_Pre.png);
      }

      .date-next {
        background: url(../../../assets/img/general/Chart_Date_Next.png);
      }

      .date-btn {
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        height: 16px;
        width: 16px;
        background-size: 100%;
        background-position: center;
        background-repeat: no-repeat;
        vertical-align: middle;
      }
    }
    }

    .tableloding {
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          background-color: #2b3842;
          color: #15c491;
        }

        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>
<style lang="less">
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }
}

.billingHistory {
  .el-table--border::after,
  .el-table--group::after {
    display: none;
  }
}
</style>
